module.exports = __webpack_public_path__ + "img/oThiago.615e4871.png";